<template>
  <div class="myContent">
    <div class="debug" @click="clear"></div>
    <div class="userinfor">
      <img :src="userInfo.avatarurl" class="headImg" alt />
      <div class="infor">
        <i class="user">
          <div class="username">{{userInfo.nickname }}</div>
          <div class="is_wholesaler" v-if="mydata.data.is_vip">批发商</div>
        </i>
        <span class="tel" v-if="mydata.data.tel">{{ mydata.data.tel }}</span>
      </div>
      <div class="money">
        <strong @click="toFinance" class="m_box">
          <span class="t1">余额：</span>
          <span class="t2">￥{{ mydata.data.balance ? mydata.data.balance: 0 }}</span>
        </strong>
        <strong class="t3" @click="toRech">
          <span>
            去充值
            <i>></i>
          </span>
        </strong>
      </div>
    </div>

    <div class="myOrder">
      <div class="top">
        <span class="t1">我的订单</span>
        <router-link :to="{ path:'/order/list',query:{type:10} }" class="allOrder">
          <span>全部订单</span>
          <div>></div>
        </router-link>
      </div>
      <div class="orderList">
        <router-link :to="{ path:'/order/list',query:{type:1} }" tag="div" class="item">
          <span class="t1" v-if="mydata.a != 0">{{ mydata.a }}</span>
          <img src="../assets/my/pay.png"  />
          <span class="t2">待付款</span>
        </router-link>
        <router-link :to="{ path:'/order/list',query:{type:2} }" tag="div" class="item">
          <span class="t1" v-if="mydata.b != 0">{{ mydata.b }}</span>
          <img src="../assets/my/deliver.png"  />
          <span class="t2">待发货</span>
        </router-link>
        <router-link :to="{ path:'/order/list',query:{type:3} }" tag="div" class="item">
          <span class="t1" v-if="mydata.c != 0">{{ mydata.c }}</span>
          <img src="../assets/my/receive.png"  />
          <span class="t2">待收货</span>
        </router-link>
        <router-link :to="{ path:'/order/list',query:{type:4} }" tag="div" class="item">
          <span class="t1" v-if="mydata.d != 0">{{ mydata.d }}</span>
          <img src="../assets/my/eva.png"  />
          <span class="t2">待评价</span>
        </router-link>
        <router-link :to="{ path:'/order/list',query:{type:5} }" tag="div" class="item">
          <!-- <span class="t1">{{ mydata.a }}</span> -->
          <img src="../assets/my/service.png"  />
          <span class="t2">售后中</span>
        </router-link>
      </div>
    </div>
    <div class="bottomBox">
      <router-link tag="div" to="/addr/index" class="item">
        <img class="img1" src="../assets/my/addr.png" alt />
        <span>我的地址</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>

      <router-link tag="div" to="Collect" class="item">
        <img class="img1" src="../assets/my/collect.png" alt />
        <span>我的收藏</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>

      <router-link tag="div" to="/foot" class="item">
        <img class="img1" src="../assets/my/foot.png" alt />
        <span>我的足迹</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>

      <router-link tag="div" :to="{name:'phone',query:{tel:mydata.data.tel}}" class="item">
        <img class="img1" src="../assets/my/aq.png" alt />
        <span>安全中心</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>

      <router-link tag="div" to="/about/index" class="item">
        <img class="img1" src="../assets/my/help.png" alt />
        <span>帮助中心</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>
      <router-link tag="div" to="/contactus" class="item">
        <img class="img1" src="../assets/my/collect.png" alt />
        <span>联系客服</span>
        <img class="img2" src="../assets/my/next2.png" alt />
      </router-link>
    </div>

    <div class="btn" @click="delCookie" v-if="is_clear.length==10">清理缓存</div>
  </div>
</template>
<style lang="less" scoped>
.myContent {
  position: relative;
  .btn {
    width: 500px;
    height: 100px;
  }
  .debug{
    width: 100px;
    height: 40px;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    opacity: 0;
  }
  .userinfor {
    width: 100%;
    height: 275px;
    background-color: #f9373f;
    display: flex;
    box-sizing: border-box;
    padding: 30px 24px;
    margin-bottom: 50px;
    position: relative;
    .headImg {
      width: 130px;
      height: 130px;
      border: 4px solid #fff;
      border-radius: 50%;
      box-sizing: border-box;
      margin-right: 10px;
    }
    .infor {
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      i {
        font-style: normal;
        margin-bottom: 10px;
      }
      .user {
        display: flex;
        align-items: center;
        .username {
          font-size: 36px;
          color: #fff;
          flex: 1;
        }
        .is_wholesaler {
          font-size: 20px;
          color: #d2c69e;
          height: 32px;
          display: flex;
          align-items: center;
          // line-height: 30px;
          width: 70px;
          border: 1Px solid #d2c69e;
          padding: 0 10px;
          border-radius: 16px;
          margin-left: 10px;
        }
      }
      .tel {
        display: block;
        font-size: 24px;
        color: #fff;
      }
    }
    .money {
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 10px;
      height: 114px;
      width: 702px;
      background: url("../assets/my/bg.png") no-repeat;
      background-size: 100% 100%;
      left: 24px;
      bottom: -31px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;
      .m_box{
        width: 70%;
        // height: 100%;
        overflow: hidden;
      }
      .t1 {
        font-size: 28px;
        vertical-align: middle;
        background: linear-gradient(-29deg,#ede7c7, #c1b58c);
        background-image: -webkit-linear-gradient(-29deg, #ede7c7, #c1b58c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .t2 {
        font-size: 46px;
        vertical-align: middle;
        background: linear-gradient(-29deg,#ede7c7, #c1b58c);
        background-image: -webkit-linear-gradient(-29deg, #ede7c7, #c1b58c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .t3 {
        font-size: 26px;
        background-image: -webkit-linear-gradient(-29deg, #ede7c7, #c1b58c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        span {
          display: flex;
          align-items: center;
        }
        i {
          margin-left: 8px;
          font-style: normal;
          font-size: 30px;
          display: block;
          transform: scaleY(1.7);
          padding-bottom: 5px;
          background-image: -webkit-linear-gradient(-29deg, #ede7c7, #c1b58c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
  .myOrder {
    width: 100%;
    height: 254px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 24px;
    margin-bottom: 20px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 90px;
      border-bottom: 1px solid #eee;
      .t1 {
        font-size: 28px;
        color: #333;
      }
      .allOrder {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #666;
        span {
          display: block;
        }
        div {
          transform: scaleY(1.8);
          margin-left: 5px;
          padding-bottom: 3px;
        }
      }
    }
    .orderList {
      width: 100%;
      height: 164px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 24px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .t1 {
          position: absolute;
          right: -0px;
          top: -10px;
          padding: 0 8px;
          height: 26px;
          line-height: 26px;
          border-radius: 13px;
          color: #fff;
          font-size: 18px;
          // z-index: 5;
          background-color: #f9373f;
        }
        img {
          width: 55px;
          height: 55px;
        }
        .t2 {
          font-size: 24px;
          color: #333;
        }
      }
    }
  }
  .bottomBox {
    .item {
      display: flex;
      align-items: center;
      width: 100%;
      height: 110px;
      margin-bottom: 2px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0 24px;
      .img1 {
        width: 30px;
        // height: 30px;
      }
      span {
        font-size: 28px;
        color: #333;
        margin-left: 12px;
        font-weight: 500;
        flex: 1;
      }
      .img2 {
        width: 20px;
        height: 40px;
      }
    }
  }
}

</style>
<script>
export default {
  data() {
    return {
      mydata: {
        data: {},
        is_clear:[]
      },
      is_clear:[]
    };
  },

  mounted() {
    // 获取个人信息
    this.$http({
      url: "my"
    }).then(res => {
      console.log(res);
      this.mydata = res;
    });
  },
  methods: {
    clear(){
      this.is_clear.push('1')
    },
    toRech() {
      console.log("充值页");
      this.$router.push({
        name: "recharge",
        params: { balance: this.mydata.data.balance }
      });
    },
    toFinance() {
      console.log("余额");
      // console.log(this.mydata)
      this.$router.push({
        name: "financeIndex",
        query: { balance: this.mydata.data.balance }
      });
    },
    delCookie() {
      console.log('11')
        let  exp = new Date()
        exp.setTime(exp.getTime() - 1)
        document.cookie = 'token' + "=" + '' + ";expires=" + exp.toGMTString();
        localStorage.removeItem('apireg');
        localStorage.removeItem('appid');
        localStorage.removeItem('fromPath');
        localStorage.removeItem('fromquery');
        localStorage.removeItem('state');
        localStorage.removeItem('userInfo');
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  }
};
</script>
